import { render, staticRenderFns } from "./SortTable.vue?vue&type=template&id=8405ac8a&scoped=true&"
import script from "./SortTable.vue?vue&type=script&lang=js&"
export * from "./SortTable.vue?vue&type=script&lang=js&"
import style0 from "./SortTable.vue?vue&type=style&index=0&id=8405ac8a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8405ac8a",
  null
  
)

export default component.exports